export const EMAIL = /^(?!.*[.+-]{2,})(?!.*[.+-]@)(?!@)[a-zA-Z0-9_]+(?:[.+-][a-zA-Z0-9_]+)*@(?=[a-zA-Z0-9])[^_@][a-zA-Z0-9.-]*(?<![.+-_])$/;
export const PHONE_NUMBER = /^( *\([0-9]{3}\) [0-9]{3}\-[0-9]{4} *)$/;
export const SSN_NUMBER = /^(\d{3})[-](\d{2})[-](\d{4})$/;
export const NON_ZERO_CURRENCY = /^(?!0*(\.0+)?$)(\d+|\d*\.\d+)$/;
export const EIN_NUMBER = /^(\d{9})$/;
export const NUMBER_TEXT_SPECIAL = '[^0-9a-zA-Z_\-]';
export const PAYEE_NAME = /^[a-zA-Z0-9 &-]+$/;
export const DISTCODE = /[1-9A-W]+/
